import React from "react";
import {Button, Input, Modal, Form} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
}

export default function CurrencyEditModal(props: ModifyModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                <Form.Item label={'币种'} name={'currency'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'名称'} name={'name'} required={true}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}
